import React from "react";

import cogsIcon from "../assets/svg/cogsColour.svg";
import lightbulbIcon from "../assets/svg/lightbulbColour.svg";
import speechIcon from "../assets/svg/speechBubblesColour.svg";

type DataType = {
  imgUrl: string;
  title: string;
  description: JSX.Element;
};

const DATA: DataType[] = [
  {
    imgUrl: speechIcon,
    title: "engage",
    description: (
      <div>
        <p>
          Most organisations implement a workplace health and wellbeing program
          to improve the overall health of their workforce. In order to do this,
          staff must be engaged with your program.
        </p>
        <p>
          Often it is the healthiest staff members that are the easiest to
          engage, but in order to improve the health and wellbeing of your
          workforce, you need to find ways to engage all staff members. Focus on
          ways to include and motivate those who demonstrate less healthy
          behaviours and are more resistant to change.
        </p>
      </div>
    ),
  },
  {
    imgUrl: lightbulbIcon,
    title: "motivate",
    description: (
      <div>
        <p>
          While reducing the risk of chronic disease will be a motivating factor
          for some people to change their health behaviours, this will not be true
          for everyone. Consulting with staff will help you to identify what
          factors might motivate them to engage with workplace health and wellbeing
          initiatives. Ensure you also identify any barriers that exist in the
          workplace currently (e.g. a biscuit tin in the staff kitchen). Some
          examples of common motivators include:
        </p>
        <ul className="bullet-fulcrum bullet-gold">
          <li>
            <p>Weight management</p>
          </li>
          <li>
            <p>Stress reduction</p>
          </li>
          <li>
            <p>Sleep improvements</p>
          </li>
          <li>
            <p>Being a good role-model for children</p>
          </li>
          <li>
            <p>Workplace incentives and comradery</p>
          </li>
        </ul>
      </div>
    ),
  },
  {
    imgUrl: cogsIcon,
    title: "action",
    description: (
      <div>
        <p>
          Once you understand what motivates your staff, you can then tailor how
          you promote your workplace health and wellbeing program in order to
          increase participation.
        </p>
      </div>
    ),
  },
];

export const MotivateEngage: React.FC<{}> = () => {
  return (
    <div className="container section-arrows">
      <div className="row mb-4">
        {DATA.map(({ imgUrl, title, description }, idx) => (
          <div key={idx} className="col-md">
            <div className="p-3 mb-3">
              <img src={imgUrl} alt={`${title} icon`} />
            </div>
            <h3 className="h4 text-warning text-uppercase">{title}</h3>
            {description}
          </div>
        ))}
      </div>
    </div>
  );
};
